/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskCraIdResult } from './ExecRiskCraIdResult';
import {
    ExecRiskCraIdResultFromJSON,
    ExecRiskCraIdResultFromJSONTyped,
    ExecRiskCraIdResultToJSON,
} from './ExecRiskCraIdResult';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedCraIdResponse
 */
export interface ExecRiskPaginatedCraIdResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedCraIdResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskCraIdResult>}
     * @memberof ExecRiskPaginatedCraIdResponse
     */
    results: Array<ExecRiskCraIdResult>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedCraIdResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedCraIdResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedCraIdResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedCraIdResponse interface.
 */
export function instanceOfExecRiskPaginatedCraIdResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedCraIdResponseFromJSON(json: any): ExecRiskPaginatedCraIdResponse {
    return ExecRiskPaginatedCraIdResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedCraIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedCraIdResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskCraIdResultFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedCraIdResponseToJSON(value?: ExecRiskPaginatedCraIdResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskCraIdResultToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

